<ng-container *ngIf="isLoading; else pageContent">
  <div class="auth-spinner">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="auth-wrap">
    <div class="auth-left">
      <div>
        <a routerLink="/" class="auth-logo-row">
          <img
            src="assets/images/BeExpert-logo (3).svg"
            alt="BeExpert"
            class="auth-logo-img"
          />
        </a>

        <h1 class="auth-left-h1" style="font-size: 2.25rem; margin-bottom: 8px;">
          Welcome to BeExpert.ai
        </h1>
        <h2 style="font-size: 1.15rem; font-weight: 700; color: #fff; margin-bottom: 16px; line-height: 1.4;">
          Your AI-powered platform for placement preparation, job opportunities, and hiring success.
        </h2>
        <p class="auth-left-sub" style="margin-bottom: 24px;">
          Continue your journey toward becoming placement-ready with personalized learning, assessments, and AI-powered interviews.
        </p>

        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Practice with AI-powered assessments and interviews
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Access placement-focused courses and quizzes
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Prepare for top companies with company-specific learning paths
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Apply for jobs and opportunities that match your profile
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Track your progress and improve every day
        </div>
      </div>

      <div class="auth-stats-bar" style="display: flex; flex-direction: column; align-items: flex-start; gap: 4px; border-top: 1px solid rgba(255, 255, 255, 0.1); padding-top: 20px;">
        <span class="auth-stat-num" style="font-size: 1.2rem; font-weight: 800; color: #fff; border-right: none; text-align: left;">1000+ Students Preparing for Placements</span>
        <span class="auth-stat-lbl" style="font-size: 0.8rem; color: rgba(255, 255, 255, 0.6); font-weight: 500; text-align: left;">Start Free • Learn Faster • Get Hired</span>
      </div>
    </div>

    <div class="auth-right">
      <a routerLink="/" class="auth-mobile-bar">
        <img src="assets/images/beExpert.svg" alt="BeExpert" />
      </a>

      <div class="auth-form-box">
        <div class="auth-form-title">Welcome Back</div>
        <div class="auth-form-sub">Login to continue</div>

        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <div class="auth-field">
            <label class="auth-label">Email</label>
            <div class="auth-phone-wrap">
              <input
                type="text"
                formControlName="email"
                class="auth-phone-input"
                placeholder="enter email"
              />
            </div>
            <small
              *ngIf="
                loginForm.controls['email'].invalid &&
                loginForm.controls['email'].touched
              "
              class="text-danger smaller-text"
              >Please enter a valid email address</small
            >
          </div>

          <button
            type="submit"
            class="auth-submit"
            [disabled]="loginForm.invalid"
          >
            Continue
          </button>
        </form>

        <div class="auth-divider">
          <span>or</span>
        </div>

        <button class="auth-submit mb-3" routerLink="/login" [queryParams]="{ redirectUrl : redirectUrl}">
          Login with Phone Number
        </button>

        <div class="auth-footer-link">
          Don't have an account? <a [routerLink]="['/mobile-verify']" [queryParams]="{ redirectUrl: redirectUrl }">Sign up free</a>
        </div>
      </div>
    </div>
  </div>
</ng-template>